import { STRIPE_CONFIG } from '../config/stripe';

/**
 * Fire-and-forget telemetry beacon for the secure-link checkout fallback.
 *
 * Records a funnel event ('shown' | 'clicked' | 'embedded_paid') via
 * /api/log-fallback-event. Never awaited and never throws — telemetry must
 * not affect the payment UI in any way.
 *
 * @param {string} event - funnel step
 * @param {Object} [opts]
 * @param {string} [opts.merchantId]
 * @param {string} [opts.ref]
 * @param {Object} [opts.meta]
 */
export function logFallbackEvent(event, { merchantId, ref, meta } = {}) {
  try {
    const apiUrl = STRIPE_CONFIG.apiBaseUrl || '/api';
    const body = JSON.stringify({ event, merchantId, ref, meta });

    // Prefer sendBeacon so the request survives a navigation (e.g. the
    // 'clicked' beacon fired right before redirecting to the hosted page).
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(`${apiUrl}/log-fallback-event`, blob);
      return;
    }

    fetch(`${apiUrl}/log-fallback-event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => { /* best-effort */ });
  } catch { /* never break the UI for telemetry */ }
}
